import React from 'react'
import Tippy from '@tippyjs/react'
import isMobile from 'ismobilejs'

const isMobileRes = isMobile(window.navigator)

type Props = import('@tippyjs/react').TippyProps & {}

const Tooltip: React.FC<Props> = ({ children, ...props }) => {
  if (!props.content || isMobileRes.phone || isMobileRes.tablet) {
    return <>{children}</>
  }

  return (
    <Tippy
      arrow={true}
      delay={[500, 0]}
      animation="shift-away-subtle"
      {...props}
    >
      {children}
    </Tippy>
  )
}

export default Tooltip
